import React, { useEffect, useState } from "react";
import { SubmitHandler, useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import FormInput from "../../../utils/FormInput";
import { FormElementModel } from "../../models/FormElementModel";
import { State } from "../../store";
import useFinalizeManager from "../FinalizePage/hooks/useFinalizeManager";
import { invoiceForm } from "../FinalizePage/inputsForm/InputPayFormModels";
import InvoiceButtons from "../FinalizePage/InvoiceButtons";
import useMyAccount from "../MyAccount/hooks/useMyAccount";
import EcardDefinition from "./ecardDefinitions";
import useECard from "./hooks/useECard";
import "./style.scss";
import { useTranslation } from "react-i18next";
import { PaymentLogos } from "../../../features/PaymentLogo";
import Timer from "../FinalizePage/Timer";
import BasketSummary from "../FinalizePage/BasketSummary";
import EAButton from "../shared/Buttons/EAButton";
import ConsentInputs from "../FinalizePage/ConsentInputs/ConsentInputs";
import EAPageMessage from "../shared/EAPageMessage";
import useFacility from "../../../utils/hooks/useFacility";

export type InputsFinalize = {
  depositIds: string;
  firstName: string;
  lastName: string;
  email: string;
  repeatEmail: string;
  phone: string;
  city: string;
  street: string;
  houseNumber: string;
  flatNumber: string;
  zipCode: string;
  NIP: string;
  companyName: string;
  createUser: boolean;
  createInvoice: boolean;
  acceptEAktywni: boolean;
  acceptPrivacyPolicy: boolean;
  acceptStatute: boolean;
};

const CardRecharge: React.FC = () => {
  const { t } = useTranslation();
  const userData = useSelector((state: State) => state.auth.userData);
  useFinalizeManager(() => {});

  const saleConfiguration = useSelector((state: State) => state.config.configuration);

  const { type, requestGetAssortGroups, requestPaymentDefinition, paymentUrl } = useECard();
  const [invoiceType, setInvoiceType] = useState<
    "noInvoice" | "customerInvoice" | "companyInvoice" | "recipientAndPurchaserInvoice"
  >("noInvoice");

  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
    setValue,
  } = useForm<InputsFinalize>({
    defaultValues: userData,
  });

  const handleRegistration: SubmitHandler<InputsFinalize> = async (data: any) => {
    requestPaymentDefinition({ ...data, createInvoice: invoiceType !== "noInvoice" }, activeDefinition);
  };

  useEffect(() => {
    requestGetAssortGroups();
    //eslint-disable-next-line
  }, []);

  const [activeDefinition, setActiveDefinition] = useState(999);
  const [activeDefinitionPrice, setActiveDefinitionPrice] = useState(0);
  const facilityIds = useFacility();
  
  const handleState = (num: number, price: number) => {
    setActiveDefinition(num);
    setActiveDefinitionPrice(price);
  };

  const handleStateDisable = (num: number, price: number) => {};

  useMyAccount();

  return (
    <>
      {userData && (

        <>

{facilityIds === "1209" && 
   <EAPageMessage message={"<p>W naszym sklepie online możesz wygodnie doładować swój karnet wartościowy i korzystać z usług pływalni bezgotówkowo. Oferujemy doładowania, w których otrzymujesz dodatkowy rabat:</p><ul><li>150,00 zł – rabat 10%</li><li>200,00 zł – rabat 12%</li><li>300,00 zł – rabat 15%</li><li>500,00 zł – rabat 20%</li></ul><p>Karnety są ważne przez 3 miesiące od daty zakupu lub do wykorzystania środków i umożliwiają bezgotówkowe korzystanie z usług MOSiR Jasło.</p><p>Do wyboru są doładowania według rodzaju usług:</p><ul><li><strong>Karnet 8%</strong> – BASEN, KORTY, LODOWISKO</li><li><strong>Karnet 23%</strong> – SAUNA, SPA, SIŁOWNIA, FITNESS</li></ul><p>Na dole dostępna jest również opcja <b>karnetu mieszanego</b>, która umożliwia jednorazową wpłatę podzieloną na dwie grupy usług. Kwota dzielona jest proporcjonalnie:</p><ul><li><b>150 zł</b> → 100 zł (BASEN/KORTY/LODOWISKO) + 50 zł (SAUNA/SPA/SIŁOWNIA/FITNESS)</li><li><b>200 zł</b> → 134 zł + 66 zł</li><li><b>300 zł</b> → 200 zł + 100 zł</li><li><b>500 zł</b> → 334 zł + 166 zł</li></ul>"} />
}

        <form className="card-recharge" onSubmit={handleSubmit(handleRegistration)}>

          <div className="card_recharge__box">
            <h3>{t("wybierz_doladowanie")}</h3>
            <div className="ecard-definitions flex-column ">
              {type && (
                <>
                  {paymentUrl === "" ? (
                    <>
                      {type.map((item, index) => (
                        <EcardDefinition
                          key={index}
                          item={item}
                          handleState={handleState}
                          activeDefinition={activeDefinition}
                        />
                      ))}
                    </>
                  ) : (
                    <>
                      {type.map((item, index) => (
                        <EcardDefinition
                          key={index}
                          item={item}
                          handleState={handleStateDisable}
                          activeDefinition={activeDefinition}
                        />
                      ))}
                    </>
                  )}
                </>
              )}
            </div>

            {saleConfiguration.invoiceActive && (
              <>
                <h3>{t("faktura")}</h3>
                <InvoiceButtons invoiceType={invoiceType} setInvoiceType={setInvoiceType} />
              </>
            )}
          </div>

          <div className="card_recharge__box">
            {invoiceType !== "noInvoice" && (
              <div>
                <h3>{t("dane_do_faktury")}</h3>
                <div className={"inputs-customer-invoice"}>
                  {invoiceForm(register, invoiceType === "companyInvoice").map(
                    (item: FormElementModel, index: number) =>
                      item.name && <FormInput key={index} {...item} errors={errors} />
                  )}
                </div>
              </div>
            )}

            {invoiceType === "noInvoice" && (
              <div>
                {/* <h3>{t("zgody")}</h3> */}
                {/* {userPayCheckboxForm(errors, control, setValue).map((item, index) => (
                  <div className="flex-start-center" key={index}>
                    {item}
                  </div>
                ))} */}

                <ConsentInputs
                  errors={errors}
                  control={control}
                  setValue={setValue}
                  email={userData.email}
                  title={t("zgody")}
                  newsletter={true}
                />
              </div>
            )}
          </div>

          <div className="card_recharge__box">
            {invoiceType !== "noInvoice" && (
              <div>
                {/* <h3>{t("zgody")}</h3> */}
                {/* {userPayCheckboxForm(errors, control, setValue).map((item, index) => (
                  <div className="flex-start-center" key={index}>
                    {item}
                  </div>
                ))} */}
                <ConsentInputs
                  errors={errors}
                  control={control}
                  setValue={setValue}
                  email={userData.email}
                  title={t("zgody")}
                  newsletter={true}
                />
              </div>
            )}

            <BasketSummary total={activeDefinitionPrice} />

            {alert.length > 2 && <div className="alert alert-red">{alert}</div>}

            <>
              {paymentUrl === "" ? (
                <EAButton title={t("kupuje_z_obowiazkiem_zaplaty")} inputType="submit" />
              ) : (
                <>
                  {paymentUrl && (
                    <a
                      target="_blank"
                      className="button button-fill-second big full-button move-up"
                      href={paymentUrl}
                      rel="noreferrer"
                    >
                      {" "}
                      {t("przejdz_do_platnosci")}
                    </a>
                  )}

                  <span className="small-akapit">
                    {t("za_chwile_zostaniesz_automatycznie_przeniesiony_do_systemu_platnosci")}
                  </span>
                </>
              )}
            </>

            <Timer />

            <PaymentLogos />
          </div>
        </form>
        </>
      )}
    </>
  );
};

export default CardRecharge;
